export const SET_CATALOG_DISPLAY_TYPE = 'Catalog::Controls::SetDisplayType';
export const SET_CATALOG_SORT_BY = 'Catalog::Controls::SetSortBy';
export const SET_CATALOG_TOOGLE_FILTERS_BAR = 'Catalog::Controls::SetToggleFiltersMobileBar';
export const SET_CATALOG_FILTERS_VALUES_CHANGED =
  'Catalog::Controls::SetToggleFiltersValuesChanged';

export const DISPLAY_TYPE_ROW = 'row';
export const DISPLAY_TYPE_BLOCK = 'block';

export const SORT_BY_POPULARITY = '0';
export const SORT_BY_PRICE = '1';
export const SORT_BY_PRICE_DESC = '2';
